//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { StudentStatus } from './Enums';

export class FamilySearchOptions extends ItemBase {
    IDs: string[] = [];
    TeacherIDs: string[] = [];
    TagIDs: string[] = [];
    SearchText: string | null = null;
    Statuses: StudentStatus[] = [];
    AutoInvoicePending: boolean | null = null;

    constructor(initializer?: Partial<FamilySearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "FamilySearchOptions";
}
